import { useEffect } from 'react';
import { useThree } from '@react-three/fiber';
import * as THREE from 'three';
import { RoomEnvironment } from 'three/examples/jsm/environments/RoomEnvironment.js';

/**
 * Procedural PBR Environment (F9 fix, task 4.2)
 *
 * Replaces the network HDR download (`<Environment preset="city">`) with a
 * locally generated RoomEnvironment, making the viewport offline-capable
 * (Tauri desktop) and removing startup latency.
 */
export function ProceduralEnvironment() {
    const { gl, scene, invalidate } = useThree();

    useEffect(() => {
        const pmremGenerator = new THREE.PMREMGenerator(gl);
        const environmentScene = new RoomEnvironment();
        const renderTarget = pmremGenerator.fromScene(environmentScene, 0.04);
        scene.environment = renderTarget.texture;
        invalidate();

        return () => {
            scene.environment = null;
            renderTarget.dispose();
            pmremGenerator.dispose();
        };
    }, [gl, scene, invalidate]);

    return null;
}
